import { INIT_APP_STATE, SET_SITE_URL } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_SITE_URL: {
            const siteURL = action.payload;
            return Object.assign(Object.assign({}, state), { siteURL });
        }
        case INIT_APP_STATE: {
            const { siteURL, publicUserPageId, timezone, isUserAllowedToDelete } = action.payload;
            return Object.assign(Object.assign({}, state), { siteURL,
                publicUserPageId,
                timezone,
                isUserAllowedToDelete });
        }
        default:
            return state;
    }
};
export { reducer };
